import { Stack, Typography } from '@mui/material'
import { SPACING } from '@common/theme/spacing'
import { ReactNode } from 'react'

export interface EmptyStateProps {
  title: string
  message: string
  icon?: ReactNode
}

export default function EmptyState({ title, message, icon }: EmptyStateProps) {
  return (
    <Stack spacing={SPACING.minSpacing} alignItems="center" sx={{ py: SPACING.spacing2xl }}>
      {icon && <div>{icon}</div>}
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Stack>
  )
}
